import React, { PureComponent } from 'react';
import { number, shape, string, func } from 'prop-types';
import { connectRange } from 'react-instantsearch-core';
import './OLDCommonRangeFilter.scss';

class CommonRangeFilter extends PureComponent {
    static propTypes = {
        id: string,
        attribute: string,
        currentRefinement: shape({
            min: number,
            max: number,
        }).isRequired,
        min: number,
        max: number,
        onChange: func,
        refine: func.isRequired,
        closeDropdown: func,
        onFilterSelected: func,
    };

    static defaultProps = {
        attribute: '',
        id: '',
        onChange: () => {},
        min: null,
        max: null,
        closeDropdown: null,
        onFilterSelected: null,
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        if (
            prevState.currentRefinement.min !==
                nextProps.currentRefinement.min ||
            prevState.currentRefinement.max !== nextProps.currentRefinement.max
        ) {
            return {
                min: nextProps.currentRefinement.min,
                max: nextProps.currentRefinement.max,
                currentRefinement: nextProps.currentRefinement,
            };
        }
        return null;
    }

    state = {
        min: this.props.currentRefinement.min || 0,
        max: this.props.currentRefinement.max || 0,
        currentRefinement: this.props.currentRefinement, // eslint-disable-line react/no-unused-state
    };

    updateMin = event => {
        if (!isNaN(parseInt(event.target.value, 10))) {
            this.setState({
                min: parseInt(event.target.value, 10),
            });
        } else {
            this.setState({ min: ' ' }); // set space to keep controled input on firefox
        }
    };

    updateMax = event => {
        if (!isNaN(parseInt(event.target.value, 10))) {
            this.setState({
                max: parseInt(event.target.value, 10),
            });
        } else {
            this.setState({ max: ' ' }); // set space to keep controled input on firefox
        }
    };

    checkRangeValue = () => {
        if (this.state.min < this.props.min) {
            this.setState({
                min: this.props.min,
            });
        }

        if (this.state.max > this.props.max) {
            this.setState({
                max: this.props.max,
            });
        }
    };

    filterRange = () => {
        if (this.props.closeDropdown) this.props.closeDropdown();

        const range = { min: this.state.min, max: this.state.max };
        this.props.refine(range);
        this.props.onFilterSelected({
            value: [range.min, range.max],
            filterMin: range.min,
            filterMax: range.max,
        });
        this.props.onChange(range);
    };

    clearRange = () => {
        if (this.props.closeDropdown) this.props.closeDropdown();

        const range = { min: this.props.min, max: this.props.max };
        this.props.refine(range);
        this.props.onChange(range);
    };

    render() {
        const { id, min, max, attribute } = this.props;

        const isModified =
            this.props.min !== this.state.min ||
            this.props.max !== this.state.max;

        return (
            <div
                className="js-filter-slider filter-slider common-range-filter"
                id={id}
            >
                <div className="filter-slider__inputs-container">
                    <div>
                        <input
                            className="filter-slider__input js-numeric-input"
                            id={`${id}_min`}
                            type="number"
                            pattern="[0-9]*"
                            value={this.state.min}
                            data-cursor="0"
                            data-input-range={`${attribute}Min`}
                            data-qa="minField"
                            min={min}
                            max={max}
                            onChange={this.updateMin}
                            onBlur={this.checkRangeValue}
                        />
                    </div>
                    <div>
                        <input
                            className="filter-slider__input"
                            id={`${id}_max`}
                            type="number"
                            pattern="[0-9]*"
                            value={this.state.max}
                            min={min}
                            data-cursor="1"
                            data-input-range={`${attribute}Max`}
                            data-qa="maxField"
                            max={max}
                            onChange={this.updateMax}
                            onBlur={this.checkRangeValue}
                        />
                    </div>
                </div>
                <div className="filter-slider__container-button">
                    <button
                        className="button button--discreet-primary"
                        id={`filter-slider-button-${id}`}
                        data-button={`${attribute}Apply`}
                        data-qa="applyCta"
                        onClick={this.filterRange}
                    >
                        Appliquer
                    </button>
                    {isModified && (
                        <button
                            className="button button--link-primary"
                            id={`filter-slider-button-${id}`}
                            data-button={`${attribute}Clear`}
                            data-qa="clearCta"
                            onClick={this.clearRange}
                        >
                            Effacer
                        </button>
                    )}
                </div>
            </div>
        );
    }
}

export default connectRange(CommonRangeFilter);
